export enum GeneralSearchType {
  ARCHIVAL_COLLECTION = 'ARCHIVAL_COLLECTION',
  ARCHIVAL_AID = 'ARCHIVAL_AID',
  ARCHIVAL_UNIT = 'ARCHIVAL_UNIT',
  EAD_NODE = 'EAD_NODE',
}

export enum GeneralSearchEntityType {
  ARCHIVAL_COLLECTION = 'ARCHIVAL_COLLECTION',
  ARCHIVAL_AID = 'ARCHIVAL_AID',
  ARCHIVAL_UNIT = 'ARCHIVAL_UNIT',
  ORIGINATOR = 'ORIGINATOR',
  EAD_NODE = 'EAD_NODE',
  // eadnode upresnenie
  SERIES = 'SERIES',
  FILE = 'FILE',
}

export enum GeneralSearchEntityTypeORG {
  ARCHIVAL_COLLECTION = 'ARCHIVAL_COLLECTION',
  ARCHIVAL_AID = 'ARCHIVAL_AID',
  ARCHIVAL_UNIT = 'ARCHIVAL_UNIT',
  ORIGINATOR = 'ORIGINATOR',
  EAD_NODE = 'EAD_NODE',
}

type Fragment = {
  text: string;
  hash: number;
  fragment: boolean;
};

type HitField = {
  name: string;
  fragments: Fragment[];
  fragment: boolean;
};

export type GeneralSearchItemOrg = {
  id: string;
  archivalEntityType: GeneralSearchType;
  label?: string;
  created?: string;
  timeRange: string;
  hitFields: Record<string, HitField>;
};

type HitFields = Record<string, string>;

export type GeneralSearchItem = {
  archivalEntityType: GeneralSearchEntityType;
  label?: string;
  created?: string;
  timeRange: string;
  hitFields: HitFields;
  id: string;
};
